import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface SEOProps {
    titleKey?: string;
    descriptionKey?: string;
    canonicalPath?: string;
    ogImage?: string;
}

function setMetaTag(attribute: string, key: string, content: string) {
    let element = document.querySelector(`meta[${attribute}="${key}"]`);
    if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute.split('=')[0], key);
        document.head.appendChild(element);
    }
    element.setAttribute('content', content);
}

export default function SEO({ titleKey, descriptionKey, canonicalPath, ogImage }: SEOProps) {
    const { t, i18n } = useTranslation();
    const baseUrl = 'https://reputrust.ai';

    useEffect(() => {
        // Title
        const title = titleKey ? t(titleKey) : t('seo.title.home');
        document.title = title;

        // Description
        const description = descriptionKey ? t(descriptionKey) : t('seo.description.home');
        setMetaTag('name', 'description', description);

        // Canonical
        let linkCanonical = document.querySelector('link[rel="canonical"]');
        if (!linkCanonical) {
            linkCanonical = document.createElement('link');
            linkCanonical.setAttribute('rel', 'canonical');
            document.head.appendChild(linkCanonical);
        }
        const fullPath = canonicalPath || window.location.pathname;
        linkCanonical.setAttribute('href', `${baseUrl}${fullPath}`);

        // Open Graph
        const imageUrl = ogImage ? `${baseUrl}${ogImage}` : `${baseUrl}/images/og-image.png`;
        setMetaTag('property', 'og:title', title);
        setMetaTag('property', 'og:description', description);
        setMetaTag('property', 'og:url', `${baseUrl}${fullPath}`);
        setMetaTag('property', 'og:image', imageUrl);

        // Twitter Card
        setMetaTag('name', 'twitter:title', title);
        setMetaTag('name', 'twitter:description', description);
        setMetaTag('name', 'twitter:image', imageUrl);

        // Language
        document.documentElement.lang = i18n.language;

    }, [t, i18n.language, titleKey, descriptionKey, canonicalPath, ogImage]);

    return null;
}
